import { render, staticRenderFns } from "./CreateCenterDialog.vue?vue&type=template&id=61eb3abd&"
import script from "./CreateCenterDialog.vue?vue&type=script&lang=ts&"
export * from "./CreateCenterDialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports